// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"index_pageContainer_2X6M1","cardWrapper":"index_cardWrapper_2FuZl"};